import { BrandingStyle, DisabledPrompt } from "@bcm-dev/bcms-vite";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
* @function PageTitleView
* @param {FUNCTION} leftIconOnClick - Sets an onClick event handler for the left icon.
* @param {FUNCTION} rightIconOnClick - Sets an onClick event handler for the right icon.
* @return {React.Component}
* @exported true
* @description The PagaTitleView is the view for showing the page title.
*/
export default function PageTitleView(props) {
    const rightIconPoint = props.dataPoint ? { "data-point": `${ props.dataPoint }_Right_Icon` } : {};

    const title = props.title ?? "";
    const leftIcon = props.leftIcon ? <SVGAsset id={props.leftIcon} className="left-icon clickable" onClick={props.leftIconOnClick} /> : "";
    const rightIcon = props.rightIcon   
        ?   <DisabledPrompt>
                <SVGAsset id={props.rightIcon} className="right-icon clickable" onClick={props.rightIconOnClick} { ...rightIconPoint } />
            </DisabledPrompt> 
        : "";

    return (

     
     <BrandingStyle style={{"background" : "header_bg_abi22"}} className="page-title-view">
      
            <div className="flex-container flex-horizontal align-center">
                <div className="set-width left-icon-container">
                    {leftIcon}
                </div>
                <div className="flex-width text-center page-title">
                    <span>{title}</span>
                </div>
                <div className="set-width text-right right-icon-container">
                    {rightIcon}
                </div>
            </div>
       
         </BrandingStyle>
    );
}
